(function () {
  if (window.tomiMobileVariantCarouselReady) return;
  window.tomiMobileVariantCarouselReady = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function getSlides(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-tomi-mobile-variant]')).map(function (item) {
      return {
        alt: item.dataset.alt || '',
        height: item.dataset.height || '',
        src: item.dataset.src || '',
        srcset: item.dataset.srcset || '',
        url: item.dataset.url || '',
        variantId: item.dataset.variantId || '',
        width: item.dataset.width || ''
      };
    }).filter(function (slide) {
      return slide.src;
    });
  }

  function setSlide(card, index) {
    var slides = card.tomiVariantSlides || [];
    var image = card.querySelector('[data-tomi-mobile-variant-image]');
    var slide = slides[index];

    if (!image || !slide) return;

    card.tomiVariantIndex = index;
    image.src = slide.src;
    image.srcset = slide.srcset;
    image.alt = slide.alt;

    if (slide.width) image.width = slide.width;
    if (slide.height) image.height = slide.height;

    if (slide.url) {
      card.querySelectorAll('a.full-unstyled-link').forEach(function (link) {
        link.href = slide.url;
      });

      card.querySelectorAll('[data-product-url]').forEach(function (button) {
        button.setAttribute('data-product-url', slide.url);
      });
    }

    if (slide.variantId) {
      card.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = slide.variantId;
      });
    }
  }

  function move(card, direction) {
    if (!card.tomiVariantSlides) {
      card.tomiVariantSlides = getSlides(card);
      card.tomiVariantIndex = card.tomiVariantIndex || 0;
    }

    var slides = card.tomiVariantSlides || [];
    if (slides.length < 2) return;

    var current = card.tomiVariantIndex || 0;
    var next = (current + direction + slides.length) % slides.length;
    setSlide(card, next);
  }

  function getArrowDirection(target) {
    var arrow = target.closest && target.closest('[data-tomi-mobile-variant-prev], [data-tomi-mobile-variant-next]');
    if (!arrow) return null;

    return {
      arrow: arrow,
      direction: arrow.hasAttribute('data-tomi-mobile-variant-prev') ? -1 : 1
    };
  }

  function handleDelegatedArrow(event) {
    var arrowData = getArrowDirection(event.target);
    if (!arrowData) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (event.type !== 'click' && event.type !== 'pointerup' && event.type !== 'touchend') return;

    var card = arrowData.arrow.closest('[data-tomi-mobile-variant-card]');
    if (!card) return;

    var now = Date.now();
    if (card.tomiLastArrowAt && now - card.tomiLastArrowAt < 250) return;
    card.tomiLastArrowAt = now;

    move(card, arrowData.direction);
  }

  function initCard(card) {
    if (card.tomiVariantReady) return;

    var slides = getSlides(card);
    var prev = card.querySelector('[data-tomi-mobile-variant-prev]');
    var next = card.querySelector('[data-tomi-mobile-variant-next]');
    var media = card.querySelector('.card__media');

    if (!media || slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    card.tomiVariantReady = true;
    card.tomiVariantSlides = slides;
    card.tomiVariantIndex = 0;

    function keepArrowTapOnButton(event) {
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    function handleArrow(event, direction) {
      event.preventDefault();
      keepArrowTapOnButton(event);

      var now = Date.now();
      if (card.tomiLastArrowAt && now - card.tomiLastArrowAt < 250) return;
      card.tomiLastArrowAt = now;

      move(card, direction);
    }

    if (prev) {
      prev.addEventListener('pointerdown', keepArrowTapOnButton);
      prev.addEventListener('touchstart', keepArrowTapOnButton);
      prev.addEventListener('pointerup', function (event) {
        handleArrow(event, -1);
      });
      prev.addEventListener('touchend', function (event) {
        handleArrow(event, -1);
      });
      prev.addEventListener('click', function (event) {
        handleArrow(event, -1);
      });
    }

    if (next) {
      next.addEventListener('pointerdown', keepArrowTapOnButton);
      next.addEventListener('touchstart', keepArrowTapOnButton);
      next.addEventListener('pointerup', function (event) {
        handleArrow(event, 1);
      });
      next.addEventListener('touchend', function (event) {
        handleArrow(event, 1);
      });
      next.addEventListener('click', function (event) {
        handleArrow(event, 1);
      });
    }

    var startX = 0;
    var startY = 0;
    var touchStartedOnMedia = false;

    card.addEventListener('touchstart', function (event) {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      var mediaRect = media.getBoundingClientRect();
      touchStartedOnMedia = startY >= mediaRect.top && startY <= mediaRect.bottom;
    }, { passive: true });

    card.addEventListener('touchend', function (event) {
      if (!mobileQuery.matches || !startX || !touchStartedOnMedia) return;

      var touch = event.changedTouches[0];
      var deltaX = touch.clientX - startX;
      var deltaY = touch.clientY - startY;

      startX = 0;
      startY = 0;
      touchStartedOnMedia = false;

      if (Math.abs(deltaX) < 32 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      card.tomiVariantSwiped = true;
      move(card, deltaX < 0 ? 1 : -1);
    }, { passive: true });

    card.addEventListener('click', function (event) {
      if (!card.tomiVariantSwiped) return;
      event.preventDefault();
      event.stopPropagation();
      card.tomiVariantSwiped = false;
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-tomi-mobile-variant-card]').forEach(initCard);
  }

  ['pointerdown', 'touchstart', 'pointerup', 'touchend', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, handleDelegatedArrow, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var observer = new MutationObserver(function (mutations) {
    var shouldInit = mutations.some(function (mutation) {
      return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches && node.matches('[data-tomi-mobile-variant-card]') ||
          node.querySelector && node.querySelector('[data-tomi-mobile-variant-card]')
        );
      });
    });

    if (shouldInit) init();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
